import { initEnv, inBiliApp } from '@bilibili/js-bridge'
import { execRuntime, execSupport } from './../runtime'
import createAxios from './axios'
import createBridge from './bridge'
import createUpload from './upload'

export const createAdapter = async (option) => {
  if (inBiliApp) {
    initEnv()
  }

  const [runtime, support] = await Promise.all([execRuntime(), execSupport()])

  return {
    axios: createAxios(option, runtime),
    bridge: createBridge(option, runtime),
    upload: createUpload(option, support),
    config: {
      runtime,
      support
    }
  }
}
